import Button from 'components/General/Button/Button';
import { Checkbox } from 'components/General/Checkbox/Checkbox';
import Label from 'components/General/Label/Label';
import { useLogic } from './AttendanceModal.logic';
import './AttendanceModal.scss';

export const AttendanceModal = () => {
  const {
    attended,
    setAttended,
    handleSaveAttendance,
    isLoading
  } = useLogic();

  return (
    <div className="attendance-container">
      <h2>Change attendance</h2>
      <div className="attendance-option">
        <Label color="mustard">Attended</Label>
        <Checkbox
          checked={attended}
          onChange={() => setAttended(true)}
        />
      </div>
      <div className="attendance-option">
        <Label color="fuchsia">Absent</Label>
        <Checkbox
          checked={attended === false}
          onChange={() => setAttended(false)}
        />
      </div>

      <div className="mt-1">
        <Button
          color="primary"
          onClick={handleSaveAttendance}
          isLoading={isLoading}
        >
          Save
        </Button>
      </div>
    </div>
  );
};
